import { render, staticRenderFns } from "./MarqueeBlock.vue?vue&type=template&id=661c2f82&scoped=true&"
import script from "./MarqueeBlock.vue?vue&type=script&lang=js&"
export * from "./MarqueeBlock.vue?vue&type=script&lang=js&"
import style0 from "./MarqueeBlock.vue?vue&type=style&index=0&id=661c2f82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661c2f82",
  null
  
)

export default component.exports